import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isDefinedNotEmpty, Store } from '@softline/core';
import { SOFTLINE_FEATURE_MDE_ETIKETTENDRUCK } from '../etikettendruck.shared';
import { EtikettendruckStore } from '../store/etikettendruckStore';

export const etikettendruckGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const store = inject(Store);

  console.log('[etikettendruckGuard] called', { url: state.url });

  if (state.url.startsWith('/mde-etikettendruck/auswahl')) {
    console.log('[etikettendruckGuard] already on auswahl → allow');
    return true;
  }

  const art = store.get(
    SOFTLINE_FEATURE_MDE_ETIKETTENDRUCK,
    EtikettendruckStore.getters.art
  );

  console.log('[etikettendruckGuard] art=', art);

  if (!isDefinedNotEmpty(art)) {
    console.log('[etikettendruckGuard] no art → redirect to auswahl');
    return router.createUrlTree(['/mde-etikettendruck/auswahl']);
  }
  console.log('[etikettendruckGuard] has art → allow');
  return true;
};
